import type { FeaturesContent } from "./types";

export const featuresContent: FeaturesContent = {
  heading: "Features",
  intro:
    "Every feature here is live today — not a mockup, not a roadmap promise.",
  clusters: [
    {
      heading: "Build your character",
      image: {
        baseName: "feature-character",
        alt: "A character sheet showing ability scores, AC, HP, and saves for a Verderem player character",
      },
      items: [
        {
          title: "Character creation, built to the rules",
          description:
            "Forge a character through class, species, background, spells, and starting equipment — every choice checked against the actual rules as you make it. All twelve D&D 5e classes are forgeable and levelable, with real feat choices as you grow.",
        },
      ],
    },
    {
      heading: "Play by the rules",
      image: {
        baseName: "feature-actions",
        alt: "A list of available actions with their action-economy costs and rules descriptions",
      },
      items: [
        {
          title: "Combat that runs on real rules, not vibes",
          description:
            "Attack rolls, saving throws, advantage and disadvantage, critical hits, damage resistance, opportunity attacks, and reactions like Shield and Counterspell all resolve deterministically — the same way, every time.",
        },
        {
          title: "Spells that scale and interact correctly",
          description:
            "Dozens of authored spells, with real upcasting, concentration tracking, and prepared or known spell rules per class — cast a fireball at 5th level or 7th, and the engine knows the difference.",
        },
        {
          title: "Conditions that actually do something",
          description:
            "Poisoned, frightened, restrained, prone, and more all change what you can do and how your rolls go — automatically, with concentration and durations tracked for you.",
        },
        {
          title: "Tactical positioning on a real grid",
          description:
            "Movement, range, and line-of-sight are computed on an actual grid — difficult terrain, forced movement, reach, and area-of-effect spells all land exactly where they should.",
        },
      ],
    },
    {
      heading: "A world that remembers",
      image: {
        baseName: "feature-maps",
        alt: "A graph of connected locations inside a tavern, showing how Verderem tracks the map of a scene",
      },
      items: [
        {
          title: "A world that remembers what your character knows",
          description:
            "The game keeps track of what's happened and who knows what. NPCs only act on what they'd actually know — not on secrets your character never revealed.",
        },
        {
          title: "NPCs with their own voice",
          description:
            "The narrator can step into an NPC's perspective to roleplay them directly, gated by whether your character actually shares a language with them.",
        },
        {
          title: "Campaigns with real objectives",
          description:
            "Set goals the engine actually tracks and fires on — for a single encounter or an entire campaign arc, not just narrated color.",
        },
      ],
    },
  ],
  metaTitle: "Features — Verderem",
  metaDescription:
    "Character creation, real D&D 5e combat, spellcasting, and a world that remembers — a closer look at what Verderem can do today.",
};
